/**
 * Barra sticky de compra y píldora de oferta.
 *
 * La barra nace oculta (translateY en CSS) y solo aparece al scrollear más allá del umbral,
 * así que si los eventos de scroll no llegan simplemente no aparece: es un extra, nunca tapa
 * contenido. Su botón pulsa el botón REAL del formulario de la ficha, de modo que respeta el
 * color y el modo de compra que el cliente tenga elegidos; si no hay ficha en la página,
 * lleva hasta ella.
 */
(() => {
  const raiz = document.querySelector('kotashi-flotantes');
  if (!raiz) return;

  // ── Píldora (27 jul: ahora lleva al email del footer, antes llevaba a la ficha) ──
  const pill = raiz.querySelector('[data-pill]');
  if (pill && sessionStorage.getItem('kotashi_pill_cerrada') !== '1') {
    pill.hidden = false;
    pill.querySelector('[data-pill-cerrar]')?.addEventListener('click', () => {
      pill.hidden = true;
      sessionStorage.setItem('kotashi_pill_cerrada', '1');
    });
    pill.querySelector('[data-pill-ir]')?.addEventListener('click', (evento) => {
      const destino = document.getElementById('newsletter');
      if (!destino) return;
      evento.preventDefault();
      destino.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => destino.querySelector('input[type="email"]')?.focus(), 500);
    });
  }

  // ── Barra sticky ──
  const barra = raiz.querySelector('[data-barra]');
  if (!barra) return;

  const umbral = Number(getComputedStyle(barra).getPropertyValue('--kbarra-umbral')) || 900;

  const alScrollear = () => {
    barra.classList.toggle('is-visible', window.scrollY > umbral);
  };
  window.addEventListener('scroll', alScrollear, { passive: true });
  alScrollear();

  barra.querySelector('[data-barra-comprar]')?.addEventListener('click', () => {
    const botonReal = document.querySelector('.kotashi-ficha kotashi-compra [ref="boton"]');
    if (botonReal) {
      botonReal.click();
    } else {
      document.getElementById('comprar')?.scrollIntoView({ behavior: 'smooth' });
    }
  });
})();
